import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/sy_bg.jpg';
import _imports_1 from '@/assets/img/公司简介.png';
import _imports_2 from '@/assets/img/pic.png';
import _imports_3 from '@/assets/img/jj1.png';
import _imports_4 from '@/assets/img/公司战略.png';
import _imports_5 from '@/assets/img/公司团队.png';
const _withScopeId = n => (_pushScopeId("data-v-5281726d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-5281726d><img src=\"" + _imports_0 + "\" alt=\"\" data-v-5281726d></div><div class=\"company_jj\" data-v-5281726d><img src=\"" + _imports_1 + "\" alt=\"\" data-v-5281726d><p data-v-5281726d> 公司专注软件和信息技术服务业、电信增值产品运营、计算机信息技术咨询、产品运营、互联网资源整合、自媒体运营、APP推广服务、音乐内容推广合作、渠道联盟运营等，在各个领域都有不俗战绩；公司本着以人为本的管理模式，制定了完善的人性化激励机制，同时吸收和培养了一批优秀的管理人才。本着诚信、创新、严谨、高效的经营理念，面对广阔但竞争激烈多变的市场，公司将对核心业务进行深度挖掘，寻求多元化的业务发展模式。 </p><div class=\"pic\" data-v-5281726d><img src=\"" + _imports_2 + "\" alt=\"\" data-v-5281726d><img src=\"" + _imports_3 + "\" alt=\"\" data-v-5281726d></div></div>", 2);
const _hoisted_4 = {
  class: "bannerzl"
};
const _hoisted_5 = {
  class: "box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode(" 企业愿景：铸精品游戏，做中国EA！ "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("企业使命：聚焦玩家需求，持续创造快乐和惊喜 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("公司目标：把对制作游戏具有发自内心的共同热爱的人们聚合起来，建立世界一流的的游戏研发与运营团队，不断创造引领时代潮流的"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("精品游戏，持续为玩家带来充满惊喜的游戏体验与乐趣。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("公司价值观：一切围绕用户需求展开，一切以用户价值为依归 ")], -1));
const _hoisted_8 = {
  class: "imgs"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "bannerzl bannertd"
};
const _hoisted_11 = {
  class: "box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {
    "margin-bottom": "30px"
  },
  alt: ""
}, null, -1));
const _hoisted_13 = {
  class: "team"
};
const _hoisted_14 = ["src"];
import { reactive, ref, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const audio = new Audio();
    const currentId = ref(-1);
    const data = reactive({
      team: [{
        src: require('@/assets/img/team1.png'),
        msg: '公司具备专业的业务运营、产品设计、前后端开发团队，能够快速响应运营商业务需求，根据运营商业务上线要求及时作出优化与调整，保证业务推广规范与健康。'
      }, {
        src: require('@/assets/img/team2.png'),
        msg: '公司具备成熟完善的业务逻辑，能够快速响应用户需求，根据业务发展要求、社会动态及时作出优化与调整，保障业务推广规范与健康的同时，增加用户权益，提升用户体验感。'
      }]
    });
    onMounted(() => {
      //getlist()
      const User = window.localStorage.getItem('user');
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], item => {
        return _createElementVNode("img", {
          key: item,
          src: require(`@/assets/img/img${item}.png`),
          alt: ""
        }, null, 8, _hoisted_9);
      }), 64))])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.team, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "info",
          key: index
        }, [_createElementVNode("img", {
          src: item.src,
          alt: ""
        }, null, 8, _hoisted_14), _createElementVNode("p", null, _toDisplayString(item.msg), 1)]);
      }), 128))])])])]);
    };
  }
});